<!-- Footer -->
<p class="mb-0 d-flex flex-column flex-lg-row justify-content-lg-between">
	<span class="mt-25">
		{{ 'common_label_copyright' | translate }} &copy; {{ year }}
		<a class="ml-25" href="#" target="_blank">{{ coreConfig.app.appName }}</a>
		<span class="d-none d-sm-inline-block">{{ 'common_label_footer_rights_reserved' | translate }}</span>
	</span>
	<span> {{ 'common_label_footer_by' | translate }} <a target="_blank" href="https://www.qnomos.com/">Nomos</a> </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
@if (coreConfig.layout.scrollTop) {
	<app-scroll-top></app-scroll-top>
}
